<template>
    <div class="">
        <div class="modal fade" id="templates-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Vorlagen
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <!-- Vertical Menu Column -->
                            <div class="col-4 border-right">
                                <div class="nav flex-column nav-pills" role="tablist">
                                    <a class="nav-link active" data-toggle="pill" href="#template-1">
                                        <i class="fas fa-sm fa-fw fa-chart-bar"></i>
                                        Standardauswertung
                                    </a>
                                    <a class="nav-link" data-toggle="pill" href="#template-2">
                                        <i class="fas fa-sm fa-fw fa-chart-bar"></i>
                                        Flyerauswertung
                                    </a>
                                </div>
                            </div>

                            <!-- Content Column -->
                            <div class="col-8">
                                <div class="tab-content">
                                    <div id="template-1" class="tab-pane fade show active">
                                        <h4>Standardauswertung</h4>
                                        <p>Der Standard! Auswertung auf BGA und PZN Ebene mit Vorjahresvergleich und
                                            Entwicklung!</p>
                                        <ul>
                                            <li>
                                                Zeitraum Modus Summe
                                            </li>
                                            <li>
                                                Vergleich mit Vorjahr
                                            </li>
                                            <li>
                                                Seiten: BGA, PZN
                                            </li>
                                            <li>
                                                Sell In Anbieter, Überweiser Direktgeschäft
                                            </li>
                                            <li>
                                                Sell In Großhandel, Überweiser Direktgeschäft
                                            </li>
                                            <li>
                                                Sell Out
                                            </li>
                                            <li>
                                                NON RX Gesamt
                                            </li>
                                        </ul>
                                        <button type="button" class="btn btn-outline-primary" @click="applyTemplate(1)">
                                            <i class="fas fa-sm fa-fw fa-check"></i>
                                            Übernehmen
                                        </button>
                                    </div>
                                    <div id="template-2" class="tab-pane fade">
                                        <h4>Todo</h4>
                                        <p>Todo</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Schließen</button>
                    </div>
                </div>
            </div>
        </div>

        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-period-module :dto="config.timing" :options="options" :mode-select="true"
                              :compare="true"></timing-period-module>

        <h3 class="mb-3">Seiten</h3>

        <div class="card shadow mb-3">
            <div class="card-header">
                <ul class="nav nav-tabs card-header-tabs">
                    <li class="nav-item" :key="page._uuid" v-for="(page, index) in config.pages">
                        <a class="nav-link"
                           :class="{active: index === activePageIndex}"
                           href="#"
                           @click.prevent="activePageIndex = index">
                            <template v-if="page.title">
                                {{ page.title }}
                            </template>
                            <template v-else>
                                Seite {{ index + 1 }}
                            </template>
                            <a href="#"
                               class="text-muted"
                               v-if="index === activePageIndex"
                               @click.prevent.stop="removePage(index)">
                                <i class="fas fa-fw fa-times"></i>
                            </a>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#" @click.prevent="addPage">
                            <i class="fas fa-fw fa-plus"></i>
                            Neue Seite
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card-body" v-if="activePageIndex === null">
                <p class="card-text">
                    Fügen Sie eine Seite hinzu.
                </p>
            </div>
            <div class="card-body"
                 :key="page._uuid"
                 v-for="(page, index) in config.pages"
                 v-if="activePageIndex === index">
                <page :options="options" :dto="page" :index="index" :key="page._uuid"></page>
            </div>
        </div>

        <h3 class="mb-3">Blöcke</h3>

        <div class="card shadow mb-3">
            <div class="card-header">
                <ul class="nav nav-tabs card-header-tabs">
                    <li class="nav-item"
                        :key="block._uuid"
                        v-for="(block, index) in config.blocks">
                        <a class="nav-link"
                           :class="{active: index === activeBlockIndex, underlined: block.isPrimary && !config.autoPrimaryBlock, 'text-info': block.isPrimary && !config.autoPrimaryBlock}"
                           href="#"
                           @click.prevent="activeBlockIndex = index; showBlockSelect = false">
                            <template v-if="block.title">
                                {{ block.title }} ({{ block._label }})
                            </template>
                            <template v-else>
                                {{ block._label }}
                            </template>
                            <a href="#"
                               class="text-muted"
                               v-if="index === activeBlockIndex"
                               @click.prevent.stop="removeBlock(index)">
                                <i class="fas fa-fw fa-times"></i>
                            </a>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           :class="{active: showBlockSelect}"
                           href="#"
                           @click.prevent="showBlockSelect = true; activeBlockIndex = null">
                            <i class="fas fa-fw fa-plus"></i>
                            Neuer Block
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card-body" v-if="showBlockSelect">
                <p class="card-text">
                    Welcher Block soll hinzugefügt werden?
                </p>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click="addBlock('universal-block-sell-in')">
                    Sell In
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click="addBlock('universal-block-sell-out')">
                    Sell Out
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click="addBlock('universal-block-profit')">
                    Rohertrag
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click="addBlock('universal-block-lager')">
                    Lager
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click="addBlock('universal-block-rabatt')">
                    Rabattauswirkung
                </button>
                <button type="button"
                        class="btn btn-outline-primary"
                        @click="addBlock('universal-block-verkauf')">
                    VK Preisanalyse
                </button>
            </div>
            <div class="card-body"
                 :key="block._uuid"
                 v-for="(block, index) in config.blocks"
                 v-if="activeBlockIndex === index">
                <sell-in-block :dto="block"
                               :index="index"
                               v-if="block._type === 'universal-block-sell-in'"
                               :key="block._uuid"></sell-in-block>
                <sell-out-block :dto="block"
                                :index="index"
                                v-if="block._type === 'universal-block-sell-out'"
                                :key="block._uuid"></sell-out-block>
                <profit-block :dto="block"
                              :index="index"
                              v-if="block._type === 'universal-block-profit'"
                              :key="block._uuid"></profit-block>
                <lager-block :dto="block"
                             :index="index"
                             v-if="block._type === 'universal-block-lager'"
                             :key="block._uuid"></lager-block>
                <rabatt-block :dto="block"
                              :index="index"
                              v-if="block._type === 'universal-block-rabatt'"
                              :key="block._uuid"></rabatt-block>
                <verkauf-block :dto="block"
                              :index="index"
                              v-if="block._type === 'universal-block-verkauf'"
                              :key="block._uuid"></verkauf-block>
                <template v-if="config.autoPrimaryBlock">
                    <small class="text-muted">
                        Der primäre Block wird automatisch bestimmt (Block mit der größten Datenabdeckung).
                        Die manuelle Auswahl kann unter "Optionen" aktiviert werden.
                    </small>
                </template>
                <template v-else-if="block.isPrimary">
                    <small class="text-info">Block ist primärer Block.</small>
                </template>
                <template v-else>
                    <button type="button" class="btn btn-sm btn-outline-info" @click="makePrimary(block)">
                        Zum primären Block machen
                    </button>
                </template>
            </div>
        </div>

        <template v-if="!(options.disabledFeatures || []).includes('panel_settings')">
        <h3 class="mb-3">Weitere Einstellungen</h3>

        <div class="card shadow mb-3">
            <div class="card-header">
                Prozentregelung
            </div>
            <div class="card-body" v-if="!panelConfigVisible">
                Die Prozentregelung kann nur angewendet werden, wenn Vorjahresvergleich aktiv und es eine Seite mit
                Hauptgruppierung "BGA" gibt.
            </div>
            <div class="card-body" v-else>
                <div class="form-group" v-if="config.timing.comparePeriods">
                    <label>
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['panel.panelPercent']"></i>
                        Panelgröße
                    </label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Prozent</span>
                        </div>
                        <input type="text" class="form-control" placeholder="100" v-model="config.panelPercent">
                    </div>
                </div>

                <div class="form-group">
                    <label>
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['panel.panelBase']"></i>
                        Berechnungsgrundlage
                    </label>
                    <select class="form-control" v-model="config.panelBlockUuid">
                        <option :value="null">Bitte auswählen</option>
                        <option :value="block._uuid"
                                :disabled="!panelBlockSelectable(block)"
                                :key="block._uuid"
                                v-for="(block, index) in config.blocks">
                            #{{ index + 1 }}
                            {{ block._label }}
                            <template v-if="block.title">
                                ({{ block.title }})
                            </template>
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label>
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['markt.panelFilter']"></i>
                        Filter PZN
                    </label>
                    <custom-select v-model="config.panelPzn"
                                   ref="panelPzn"
                                   :settings="panelPznSettings"/>
                </div>

                <div class="form-group">
                    <label>
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['markt.panelFilter']"></i>
                        Filter Anbieter
                    </label>
                    <custom-select v-model="config.panelAnbieter"
                                   :settings="panelAnbieterSettings"/>
                    <div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" :name="'panel' + 'anbieterMode'"
                                   :id="'panel' + 'anbieterModeInklusiv'"
                                   value="inclusive"
                                   v-model="config.panelAnbieterMode">
                            <label class="form-check-label" :for="'panel' + 'anbieterModeInklusiv'">
                                Inklusiv
                            </label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" :name="'panel' + 'anbieterMode'"
                                   :id="'panel' + 'anbieterModeExklusiv'"
                                   value="exclusive"
                                   v-model="config.panelAnbieterMode">
                            <label class="form-check-label" :for="'panel' + 'anbieterModeExklusiv'">
                                Exklusiv
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </template>

        <div class="card shadow mb-3">
            <div class="card-header">
                Optionen
            </div>

            <div class="card-body">

                <div class="form-group">
                    <label>Primärer Block</label>
                    <div class="form-check my-1">
                        <input class="form-check-input" type="checkbox"
                               id="auto-primary-block"
                               v-model="config.autoPrimaryBlock">
                        <label class="form-check-label" for="auto-primary-block">
                            Automatisch bestimmen (Block mit der größten Datenabdeckung)
                        </label>
                    </div>
                    <small class="text-muted" v-if="!config.autoPrimaryBlock">
                        Der primäre Block kann in den Einstellungen des jeweiligen Blocks ausgewählt werden.
                    </small>
                </div>

                <div class="form-group">
                    <label>Max. Anzahl Zeilen der Hauptgruppen</label>
                    <div class="form-check my-1">
                        <input class="form-check-input" type="checkbox"
                               id="parent-row-limit"
                               @change="config.parentRowLimit === null ? config.parentRowLimit = 10 : config.parentRowLimit = null"
                               :checked="config.parentRowLimit === null">
                        <label class="form-check-label" for="parent-row-limit">
                            Maximale Anzahl
                        </label>
                    </div>
                    <input type="text"
                           class="form-control"
                           v-model="config.parentRowLimit"
                           placeholder="10"
                           v-if="config.parentRowLimit !== null">
                </div>

                <div class="form-group">
                    <label>Max. Anzahl Zeilen der Untergruppen</label>
                    <div class="form-check my-1">
                        <input class="form-check-input" type="checkbox"
                               id="children-row-limit"
                               @change="config.childrenRowLimit === null ? config.childrenRowLimit = 10 : config.childrenRowLimit = null"
                               :checked="config.childrenRowLimit === null">
                        <label class="form-check-label" for="children-row-limit">
                            Maximale Anzahl
                        </label>
                    </div>
                    <input type="text"
                           class="form-control"
                           v-model="config.childrenRowLimit"
                           placeholder="10"
                           v-if="config.childrenRowLimit !== null">
                </div>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :pharmacies="true"
                          :pharmacies-mode="true"
                          :pharmacies-coop-split="true"
                          :pzn-fill-empty="false"
                          :pzn-groups="false"
                          :wholesalers="true"
                          :warengruppen="true"
                          :anbieter-mode="true"
                          :sell-in-mode-switch="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="true"
                          :umsatz="true"
                          :reimport="true"></filtering-module>

        <pre>{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../../Modules/TimingPeriodModule";
import FilteringModule from "../../Modules/FilteringModule";
import Page from "./Page.vue";
import SellInBlock from "./SellInBlock.vue";
import SellOutBlock from "./SellOutBlock.vue";
import ProfitBlock from "./ProfitBlock.vue";
import LagerBlock from "./LagerBlock.vue";
import RabattBlock from "./RabattBlock.vue";
import VerkaufBlock from "./VerkaufBlock.vue";

export default {
    components: {
        FilteringModule,
        TimingPeriodModule,
        Page,
        SellInBlock,
        SellOutBlock,
        ProfitBlock,
        LagerBlock,
        RabattBlock,
        VerkaufBlock
    },
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        const hasPages = this.dto.pages.length > 0;
        const hasBlocks = this.dto.blocks.length > 0;

        return {
            config: this.dto,
            activePageIndex: hasPages ? 0 : null,
            activeBlockIndex: hasBlocks ? 0 : null,
            showBlockSelect: !hasBlocks,
            // panel
            panelPznSettings: {
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
            panelAnbieterSettings: {
                ajax: {
                    url: '/select/anbieter',
                    dataType: 'json'
                },
                multiple: true,
                tags: true,
                tokenSeparators: [',']
            },
        };
    },
    mounted() {
        // inject template button
        const templatesButton = $(`
            <button type="button" class="btn btn-sm btn-outline-secondary shadow-sm mr-2">
                <i class="fas fa-sm fa-fw fa-list"></i>
                Vorlagen
            </button>
        `);
        $('#create-button-row').prepend(templatesButton);
        templatesButton.click(() => {
            $('#templates-modal').modal();
        });

        // inject form callback for validation
        window.checkFormCallback = () => {
            if (!this.config.pages.length) {
                alert('Bitte Seiten anlegen');

                return false;
            }
            if (!this.config.blocks.length) {
                alert('Bitte Blöcke anlegen');

                return false;
            }
            if (this.panelConfigVisible && this.config.panelPercent.trim() !== '100' && !this.config.panelBlockUuid) {
                alert('Bitte Panel Berechnungsgrundlage auswählen');

                return false;
            }
            if (!this.config.filtering.pharmacies.length && !this.config.filtering.pharmaciesLists.length) {
                alert('Bitte Apotheken auswählen');

                return false;
            }

            return true;
        };
    },
    methods: {
        addPage(options = {}) {
            const defaultGroupingOptions = {
                removeEmptyRows: true,
                warengruppeMask: 6,
                timeMode: 'monthly',
                bgaSalesMode: 'sell_in',
                bgaSalesSellInMode: 'grosshandel',
                bgaSalesAbgaberegelung: 'all',
                bgaSalesStepping: '50.000',
                bgaZipMask: 4,
                universalGroupsListId: null
            };
            const newLength = this.config.pages.push({
                _uuid: this.$uuid.v4(),
                title: '',
                parentGrouping: {
                    ...defaultGroupingOptions,
                    type: 'bga',
                    hiddenColumns: []
                },
                childrenGrouping: {
                    ...defaultGroupingOptions,
                    type: null,
                    hiddenColumns: []
                },
                ...options
            });
            this.activePageIndex = newLength - 1;
        },
        removePage(index, confirmed = false) {
            if (confirmed || confirm('Seite wirklich löschen?')) {
                const isLastPage = this.config.pages.length - 1 === index;
                this.config.pages.splice(index, 1);
                if (this.config.pages.length) {
                    this.activePageIndex = isLastPage ? index - 1 : index;
                } else {
                    this.activePageIndex = null;
                }
            }
        },
        addBlock(type, options = {}) {
            const config = {
                _uuid: this.$uuid.v4(),
                _type: type,
                title: '',
                isPrimary: false
            };
            let newLength;
            if (type === 'universal-block-sell-in') {
                newLength = this.config.blocks.push({
                    ...config,
                    _label: 'Sell In',
                    hiddenColumns: ['absatz-anteil', 'umsatz-anteil'],
                    mode: 'all-sum',
                    base: 'listenEk',
                    removeTax: false,
                    ...options
                });
            }
            if (type === 'universal-block-sell-out') {
                newLength = this.config.blocks.push({
                    ...config,
                    _label: 'Sell Out',
                    hiddenColumns: ['absatz-anteil', 'umsatz-anteil'],
                    base: 'listenVk',
                    removeTax: false,
                    verkaufsartFilter: [],
                    ...options
                });
            }
            if (type === 'universal-block-profit') {
                newLength = this.config.blocks.push({
                    ...config,
                    _label: 'Rohertrag',
                    hiddenColumns: [],
                    regularProfit: true,
                    calculatedProfit: true,
                    listenEkProfit: true,
                    ...options
                });
            }
            if (type === 'universal-block-lager') {
                newLength = this.config.blocks.push({
                    ...config,
                    _label: 'Lager',
                    hiddenColumns: [],
                    sellOutRemoveTax: false,
                    stockMode: 'none',
                    verfallMode: 'all',
                    anLagerMode: 'all',
                    ...options
                });
            }
            if (type === 'universal-block-rabatt') {
                newLength = this.config.blocks.push({
                    ...config,
                    _label: 'Rabattauswirkung',
                    hiddenColumns: [],
                    sellInModeSwitch: false,
                    rabattMode: 'auto',
                    ...options
                });
            }
            if (type === 'universal-block-verkauf') {
                newLength = this.config.blocks.push({
                    ...config,
                    _label: 'Verkaufspreise',
                    hiddenColumns: [],
                    sellOutLeftBase: 'listenVk',
                    sellOutRightBase: 'kalkulierterVk',
                    compareOperator: 'none',
                    compareMode: 'relative',
                    ...options
                });
            }
            this.activeBlockIndex = newLength - 1;
            this.showBlockSelect = false;
            this.ensurePrimaryBlock();

            return this.config.blocks[newLength - 1];
        },
        removeBlock(index, confirmed = false) {
            if (confirmed || confirm('Block wirklich löschen?')) {
                const blockUuid = this.config.blocks[index]._uuid;
                const isLastBlock = this.config.blocks.length - 1 === index;
                this.config.blocks.splice(index, 1);
                if (this.config.blocks.length) {
                    this.activeBlockIndex = isLastBlock ? index - 1 : index;
                } else {
                    this.activeBlockIndex = null;
                    this.showBlockSelect = true;
                }
                // panel reset
                if (this.config.panelBlockUuid === blockUuid) {
                    this.config.panelBlockUuid = null;
                    alert('Achtung, bitte die Panel Berechnungsgrundlage anpassen.');
                }
                this.ensurePrimaryBlock();
            }
        },
        ensurePrimaryBlock() {
            // if there is no primary block, then the first one will be primary
            let hasPrimary = false;
            for (const block of this.config.blocks) {
                if (block.isPrimary) {
                    hasPrimary = true;

                    break;
                }
            }
            if (!hasPrimary && this.config.blocks.length) {
                this.config.blocks[0].isPrimary = true;
            }
        },
        makePrimary(block) {
            for (const block of this.config.blocks) {
                block.isPrimary = false;
            }
            block.isPrimary = true;
        },
        panelBlockSelectable(block) {
            return [
                'universal-block-sell-in',
                'universal-block-sell-out',
            ].includes(block._type);
        },
        applyTemplate(type) {
            $('#templates-modal').modal('hide');

            // standardauswertung
            if (type === 1) {
                this.config.timing.periodMode = 'full';
                this.config.timing.comparePeriods = true;
                this.config.pages = [];
                this.addPage({
                    parentGrouping: {
                        type: 'bga',
                        hiddenColumns: []
                    }
                });
                this.addPage({
                    parentGrouping: {
                        type: 'pzn',
                        hiddenColumns: []
                    }
                });
                this.config.blocks = [];
                this.addBlock('universal-block-sell-in', {
                    title: 'Sell In Anbieter',
                    mode: 'anbieter'
                });
                this.addBlock('universal-block-sell-in', {
                    title: 'Sell In Großhandel',
                    mode: 'grosshandel'
                });
                const sellOutBlock = this.addBlock('universal-block-sell-out', {
                    title: 'Sell Out',
                    base: 'listenVkFallback',
                });
                this.makePrimary(sellOutBlock);
                this.config.panelPercent = '100';
                this.config.panelBlockUuid = sellOutBlock._uuid;
                this.config.filtering.abgaberegelung = 'nonrx-full';
            }
        }
    },
    computed: {
        panelConfigVisible() {
            // compare periods must be enabled
            const comparePeriodsActive = this.config.timing.comparePeriods;

            // there must be at least one page with parent grouping "bga"
            let bgaPageAvailable = false;
            for (const page of this.config.pages) {
                if (page.parentGrouping.type === 'bga') {
                    bgaPageAvailable = true;

                    break;
                }
            }

            return comparePeriodsActive && bgaPageAvailable;
        },
    },
}
</script>

<style>
.underlined {
    text-decoration: underline !important;
}
</style>
